"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pieve-fosciana": {
    "e5f4b2cc": [{
      "hkey": "58e89306",
      "slug": "pieve-fosciana",
      "name": "Pieve Fosciana",
      "primary": true,
      "skipSearch": false
    }],
    "bargecchia": [{
      "hkey": "58e89306",
      "slug": "pieve-fosciana",
      "name": "Pieve Fosciana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "60489935": [{
      "hkey": "58e89306",
      "slug": "pieve-fosciana",
      "name": "Pieve Fosciana",
      "primary": true,
      "skipSearch": false
    }],
    "capraia": [{
      "hkey": "58e89306",
      "slug": "pieve-fosciana",
      "name": "Pieve Fosciana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;